module.exports = __webpack_public_path__ + "static/media/1.1 Servatius Montage ohne Objekte klein.da173469.jpg";